/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient } from 'vue-query'
import {
  UserOnboardingDto,
  UserOnboardingStepDto,
  UserOnboardingStepKey,
} from '@/api/contracts/models'
import QueryKeys from './QueryKeys'
import MutationKeys from './MutationKeys'

const MUTATION_TO_STEP: Partial<Record<MutationKeys, UserOnboardingStepKey>> = {
  [MutationKeys.CreateBankAccount]: UserOnboardingStepKey.AddBankAccount,
  [MutationKeys.SetupBankAccountsFromConnection]:
    UserOnboardingStepKey.AddBankAccount,
  [MutationKeys.SetTarget]: UserOnboardingStepKey.CreateTarget,
  [MutationKeys.CreateOrUpdatePlan]: UserOnboardingStepKey.AssignMoney,
}

function getOnboardingStep(mutation: any): UserOnboardingStepKey | undefined {
  const key = mutation?.options?.mutationKey?.[0] as MutationKeys | undefined

  return key ? MUTATION_TO_STEP[key] : undefined
}

export function createOnboardingMutationCacheOptions(
  getQueryClient: () => QueryClient,
): any {
  const onboardingKey = [QueryKeys.UserOnboarding]

  return {
    onMutate(_variables: unknown, mutation: any) {
      const stepKey = getOnboardingStep(mutation)

      if (!stepKey) return

      getQueryClient().setQueryData<UserOnboardingDto>(onboardingKey, (old) => {
        if (!old) return old

        const steps = (old.steps ?? []).map(
          (s): UserOnboardingStepDto =>
            s.stepKey === stepKey
              ? { ...s, isCompleted: true, completedAt: new Date() }
              : s,
        )
        const allDone = steps.every((s) => s.isCompleted)

        return {
          ...old,
          steps,
          isCompleted: allDone,
          completedAt: allDone ? new Date() : old.completedAt,
        }
      })
    },

    onError(
      _error: unknown,
      _variables: unknown,
      _context: unknown,
      mutation: any,
    ) {
      if (!getOnboardingStep(mutation)) return

      getQueryClient().invalidateQueries({ queryKey: onboardingKey })
    },

    onSuccess(
      _data: unknown,
      _variables: unknown,
      _context: unknown,
      mutation: any,
    ) {
      if (!getOnboardingStep(mutation)) return

      getQueryClient().invalidateQueries({ queryKey: onboardingKey })
    },
  }
}
